import React from "react";
import { formatCurrency } from "../../../../utils/SamuiUtils";

export default React.memo(function DataTable({
  fields,
  data,
  onSort,
  sortField,
  sortOrder,
  onRowClick,
  sums,
}) {
  return (
    <div className="card p-2">
      <div
        className="table-responsive"
        style={{ height: "70vh", overflowY: "auto" }}
      >
        <table className="table table-striped table-hover">
          <thead className="thead-dark">
            <tr>

              {fields.map((f) => (
                <th
                  key={f.key}
                  style={{
                    width: f.w,
                    cursor: f.sortable ? "pointer" : "default",
                  }}
                  className={`text-${f.alignHeader} text-nowrap`}
                  onClick={() => f.sortable && onSort(f.key)}
                >
                  {f.label}
                  {f.sortable && (
                    <span className="ms-1">
                      {f.key === sortField ? (
                        sortOrder === "asc" ? (
                          <i className="fas fa-sort-up text-white"></i>
                        ) : (
                          <i className="fas fa-sort-down text-white"></i>
                        )
                      ) : (
                        <i className="fas fa-sort text-muted" style={{ opacity: 0.5 }}></i>
                      )}
                    </span>
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.length ? (
              data.map((item, i) => (
                <tr
                  key={i}
                  style={{ cursor: "pointer" }}
                  onClick={() => onRowClick(i)}
                >
                  {fields.map((f) => {
                    const isPaid = f.key === "paid";
                    const isUnpaid = f.key === "unpaid";
                    const colorCls = isPaid
                      ? "text-success"
                      : isUnpaid
                        ? "text-danger "
                        : "";

                    return (
                      <td
                        key={f.key}
                        className={`text-${f.align} ${colorCls}`}
                        onClick={() => f.sortable && onSort(f.key)}
                      >
                        {f.numeric
                          ? formatCurrency(item[f.key])
                          : item[f.key]}
                      </td>
                    );
                  })}

                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={fields.length + 1}>
                  <center>
                    <h5>ไม่พบข้อมูล</h5>
                  </center>
                </td>
              </tr>
            )}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={2} className="text-end">
                รวมทั้งหมด {data.length} รายการ
              </th>
              <th className="text-end">
                {sums.sumPaid || 0}
              </th>
              <th className="text-end">
                {sums.sumUnpaid || 0}
              </th>
              <th colSpan={fields.length - 1} className="text-end">
                {sums.sumNetTotal || 0}
              </th>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
});
